/* eslint-disable @typescript-eslint/consistent-type-assertions */
import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Box } from '@mui/system';
import { theme } from 'theme';

export const AppWrapper = styled(Box)`
  display: block;
  min-height: 240px;
  height: auto;
  position: relative;
  margin: 0 8px;

  ${({ theme }) => (theme as any).breakpoints.down('md')} {
    min-height: 195px;
    margin: 0;
  }

  .page-title {
    font-size: 80px;
    line-height: 80px;
    padding-top: 25px;

    ${({ theme }) => (theme as any).breakpoints.down('md')} {
      font-size: 36px;
      line-height: 40px;
      padding-top: 0;
    }
  }
`;

export const BannersList = styled(Grid)`
  padding: 0.5em;
  margin-bottom: 1.5em;
  min-height: 210px;
  .MuiGrid-item > a > div {
    background-color: ${theme.palette.grey[50]};
  }
`;
